import React from 'react';
import {
  Box,
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
} from '@razorpay/blade/components';
import { PFWageCalculationType } from 'api/employeeOnboarding';
import { RegisterGenericType } from 'forms/useRegister';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import { toIndianCurrencyString } from 'utils/Numbers';
import useReduxSelector from 'utils/useReduxSelector';

export const PFWageCalculationSelectInput = ({
  registerFormData,
}: {
  registerFormData: RegisterGenericType<{ pfWagesCalculationType: PFWageCalculationType[] }>;
}) => {
  const pfCeilingDisplay = useReduxSelector(loggedInUserSelectors.pfCeilingDisplay);

  // The ceiling this org is actually on, resolved server-side by PfWageCeiling::displayForOrg:
  // ₹15,000 only where use15kPfLimit pins September 2026 to the legacy limit, ₹25,000 otherwise
  // — which is the default from September 2026 onwards, and the prorated path too. Hardcoding
  // ₹15,000 here left the label contradicting the note directly below it, which already reads
  // from the same source.
  //
  // Only the label moves. The stored value stays '15k' because it is the existing enum for
  // "cap at the statutory limit", not a reference to an amount.
  const pfWageCalculationTypes: Array<{
    title: string;
    value: PFWageCalculationType;
  }> = [
    {
      title: 'Use Company Default',
      value: 'default',
    },
    {
      title: `Use ${toIndianCurrencyString(pfCeilingDisplay.limit)} Limit`,
      value: '15k',
    },
    {
      title: 'No Limit',
      value: 'no_limit',
    },
  ];

  return (
    <Box>
      <Dropdown selectionType="single">
        <SelectInput
          label="PF Wage Calculation"
          labelPosition="top"
          {...registerFormData('pfWagesCalculationType', 'select')}
          isRequired
          necessityIndicator="required"
        />
        <DropdownOverlay>
          <ActionList>
            {pfWageCalculationTypes.map((type) => (
              <ActionListItem key={type.value} title={type.title} value={type.value} />
            ))}
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
    </Box>
  );
};
